import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './QuestionCard.css';

const QuestionCard = ({
  question,
  answer,
  error,
  language,
  onAnswerChange,
  index,
  isBonus = false
}) => {
  const [showHelp, setShowHelp] = useState(false);

  const getText = (textObj) => {
    if (!textObj) return '';
    return textObj[language] || textObj.en || '';
  };

  const handleScoreClick = (value) => {
    onAnswerChange(question.key, value);
  };

  const handleBonusChange = (value) => {
    onAnswerChange(question.key, value);
  };

  const renderScoredQuestion = () => {
    const scores = Array.from({ length: question.maxScore || 5 }, (_, i) => i + 1);

    return (
      <div className="question-scores">
        <div className="score-labels">
          <span className="score-label-start">
            {language === 'mr' ? 'असहमत' : 'Disagree'}
          </span>
          <span className="score-label-end">
            {language === 'mr' ? 'सहमत' : 'Agree'}
          </span>
        </div>
        <div className="score-options">
          {scores.map(score => (
            <button
              key={score}
              className={`score-btn ${answer === score ? 'selected' : ''}`}
              onClick={() => handleScoreClick(score)}
              type="button"
            >
              {score}
            </button>
          ))}
        </div>
      </div>
    );
  };

  const renderBonusQuestion = () => {
    if (!question.bonusChoices || question.bonusChoices.length === 0) {
      return (
        <input
          type="text"
          className="bonus-input"
          value={answer || ''}
          onChange={(e) => handleBonusChange(e.target.value)}
          placeholder={language === 'mr' ? 'आपले उत्तर प्रविष्ट करा' : 'Enter your answer'}
        />
      );
    }

    return (
      <div className="bonus-choices">
        {question.bonusChoices.map((choice, idx) => (
          <button
            key={idx}
            className={`bonus-choice-btn ${answer === choice ? 'selected' : ''}`}
            onClick={() => handleBonusChange(choice)}
            type="button"
          >
            {choice}
          </button>
        ))}
      </div>
    );
  };

  const questionText = getText(question.text);
  const helpText = getText(question.helpText);

  return (
    <motion.div
      className={`question-card ${error ? 'has-error' : ''}`}
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: false, margin: "-50px" }}
      transition={{ duration: 0.5 }}
    >
      <div className="question-header">
        <div className="question-number">{index + 1}</div>
        <div className="question-text-container">
          <p className="question-text">{questionText}</p>
          {helpText && (
            <button
              className="help-btn"
              onClick={() => setShowHelp(!showHelp)}
              type="button"
              title={language === 'mr' ? 'मदत' : 'Help'}
            >
              <span className="help-icon">?</span>
            </button>
          )}
        </div>
      </div>

      {showHelp && helpText && (
        <motion.div
          className="help-text"
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          exit={{ opacity: 0, height: 0 }}
        >
          <p>{helpText}</p>
        </motion.div>
      )}

      <div className="question-answer">
        {isBonus ? renderBonusQuestion() : renderScoredQuestion()}
      </div>

      {error && (
        <motion.div
          className="question-error"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
        >
          {error}
        </motion.div>
      )}
    </motion.div>
  );
};

export default QuestionCard;
